<template>
  <div>
    <transition name="fade">
      <div
        v-show="!clicked"
        class="home grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 px-20 gap-32 md:pt-10 center mb-10"
      >
        <Mood
          v-for="(mood, index) in randomizedMoods"
          :key="index"
          @click.native="modalClicked(mood)"
          :mood="mood"
          class="m-auto mood"
        />
      </div>
    </transition>
    <transition name="fade">
      <Modal
        v-if="clicked"
        :mood="currentMood"
        v-on:close-modal="clicked = !clicked"
      />
    </transition>
  </div>
</template>

<script>
// @ is an alias to /src
import Mood from "@/components/Mood.vue";
import Modal from "@/components/Modal.vue";

export default {
  name: "Home",
  data() {
    return {
      clicked: false,
      currentMood: "",
      moods: [
        {
          name: "journe",
          image: "journey.gif",
          playlistID: "1123233562",
          curator: "moodfm"
        },
        {
          name: "chill",
          image: "chill.gif",
          playlistID: "1123220131",
          curator: "moodfm"
        },
        {
          name: "groovy-house",
          image: "groovy-house.gif",
          playlistID: "1122709669",
          curator: "moodfm"
        },
        {
          name: "90s",
          image: "90s.gif",
          playlistID: "1104580600",
          curator: "moodfm"
        },
        {
          name: "chill-hop",
          image: "chill-hop.gif",
          playlistID: "1104580600",
          curator: "moodfm"
        },
        {
          name: "Blast off",
          image: "blast-off.gif",
          playlistID: "1123781539",
          curator: "Daniel W"
        },
        {
          name: "Smoothie",
          image: "smoothie.gif",
          playlistID: "1124360503",
          curator: "David M"
        },
        {
          name: "Al Dente",
          image: "al-dente.gif",
          playlistID: "1124422369",
          curator: "Benji D"
        },
        {
          name: "If you don't know, now you know",
          image: "know.gif",
          playlistID: "1123735189",
          curator: "Josh S-M"
        },
        {
          name: "Intergalactic Cruise Control",
          image: "intergalactic.gif",
          playlistID: "1127748010",
          curator: "Dustin B"
        },
        {
          name: "Acid",
          image: "acid.gif",
          playlistID: "1148519263",
          curator: "Jake A"
        }
      ]
    };
  },
  methods: {
    modalClicked(currentMood) {
      this.currentMood = currentMood;
      this.clicked = true;
    }
  },
  computed: {
    randomizedMoods: function() {
      let array = this.moods;
      var currentIndex = array.length,
        temporaryValue,
        randomIndex;

      // While there remain elements to shuffle...
      while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }

      return array;
    }
  },
  components: {
    Mood,
    Modal
  }
};
</script>

<style scoped>
.center {
  justify-content: center;
}

.grid {
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
